import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { useNavigate } from "react-router-dom"
import CategorySelect from '../../ticket/selectBox'
import axios from '../../../functions/requestInterceptor'
import { useTranslation } from 'react-i18next';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 310,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  borderRadius: '8px'
};

export default function CategoryModal(props) {
  const { t, i18n } = useTranslation('translation', { keyPrefix: 'dashboard' });

  const navigate = useNavigate()

  const [open, setOpen] = useState(props.open)
  useEffect(() => {
    setOpen(props.open)
  }, [props.open])

  const [category, setCatategory] = useState('');
  const [error, setError] = useState('')
  const createNewTicket = () => {
    axios.post('/tickets/', {
      category: category
    })
    .then((response) => {
      navigate(`/ticket/${response.data.id}`)
    })
    .catch((error) => {
      if (error?.response?.status === 429) {
        setError('خطای درخواست زیاد، لطفا چند دقیقه بعد تلاش کنید.')
      } else {
        setError(error?.response?.data?.detail || t('server_error'))
      }
    });
  }

  const userCategories = props.categories?.filter(item => !item.parent)
  const direction = i18n.language === 'en' ? 'ltr' : 'rtl'

  return (
    <Modal
      open={open}
      onClose={props.handleClose}
      dir={direction}
    >
      <Box sx={style}>
        <Typography variant="h6" component="h2" align="center">
          {t('creating_new_ticket')}
        </Typography>
        <Typography variant="caption" component="span" align="center">
          {t('new_ticket_help')}
        </Typography>
        <CategorySelect
          categories={userCategories}
          handleSelectCategory={(cat) => setCatategory(cat)}
        />
        <Button
          onClick={createNewTicket}
          variant="contained"
          disabled={category === ''}
          error={error}
        >
          {t('next')}
        </Button>
        {!!error &&
          <Typography align='center' variant='caption' sx={{color: '#f42020'}}>
            {error}
          </Typography>}
      </Box>
    </Modal>
  );
}
